import { render, staticRenderFns } from "./CustomerFileList.vue?vue&type=template&id=1e90adfc&scoped=true"
import script from "./CustomerFileList.vue?vue&type=script&lang=js"
export * from "./CustomerFileList.vue?vue&type=script&lang=js"
import style0 from "./CustomerFileList.vue?vue&type=style&index=0&id=1e90adfc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e90adfc",
  null
  
)

export default component.exports